<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title></h1>
<div mat-dialog-content>
  <p class="info">There are no Dashboards available for this Application.</p>
</div>
<div mat-dialog-actions></div>
